import { memo } from 'react';
import  { useState, type PropsWithChildren } from 'react';
import { type CallbackFunc } from '@/types/types';
import Drawer from '../Drawer';
import styles from './DrawerOverlay.module.css';


export interface OverlayProps extends PropsWithChildren {
    drawerWidth: number;
    open: boolean;
    onClosed: CallbackFunc;
}

function _drawerOverlay(props: OverlayProps) {
  const [closing, setClosing] = useState(false);
  const overlayClasses = [styles.overlay];

  const onClose = () => {
    if (!props.open) {
      return;
    }
    setTimeout(() => { 
      setClosing(false);
      props.onClosed();
    }, 300);
    setClosing(true);
  }

  if (props.open) {
    overlayClasses.push(styles.open);
  } else {
    overlayClasses.push(styles.closed);
  }

  return (
      <div className={overlayClasses.join(' ')} onClick={onClose}>
        <Drawer width={props.drawerWidth} onClose={onClose} open={props.open && !closing} >
          {props.children}
        </Drawer>
      </div>
  );
}

const DrawerOverlay = memo(_drawerOverlay);
export default DrawerOverlay;
